import { useState, useEffect } from 'react'

const useStudentListSortedByFilterString = (filterString, originalArray) => {
  const [sortedArray, setSortedArray] = useState([])

  useEffect(() => {
    const sortArrayByFilterString = (str, array) => {
      const filteredArray = array.filter(
        (item) =>
          item.item.first_name.toLowerCase().startsWith(str.toLowerCase()) ||
          item.item.last_name.toLowerCase().startsWith(str.toLowerCase()) ||
          item.item.first_name.toLowerCase().includes(str.toLowerCase()) ||
          item.item.last_name.toLowerCase().includes(str.toLowerCase())
      )

      const restArray = array.filter((item) => !filteredArray.includes(item))

      filteredArray.sort((a, b) => {
        const aFirstNameStart = a.item.first_name
          .toLowerCase()
          .startsWith(str.toLowerCase())
        const bFirstNameStart = b.item.first_name
          .toLowerCase()
          .startsWith(str.toLowerCase())
        const aLastNameStart = a.item.last_name
          .toLowerCase()
          .startsWith(str.toLowerCase())
        const bLastNameStart = b.item.last_name
          .toLowerCase()
          .startsWith(str.toLowerCase())

        if (aFirstNameStart && !bFirstNameStart) return -1
        if (!aFirstNameStart && bFirstNameStart) return 1
        if (aLastNameStart && !bLastNameStart) return -1
        if (!aLastNameStart && bLastNameStart) return 1

        const aFirstNameContains = a.item.first_name
          .toLowerCase()
          .includes(str.toLowerCase())
        const bFirstNameContains = b.item.first_name
          .toLowerCase()
          .includes(str.toLowerCase())
        const aLastNameContains = a.item.last_name
          .toLowerCase()
          .includes(str.toLowerCase())
        const bLastNameContains = b.item.last_name
          .toLowerCase()
          .includes(str.toLowerCase())

        if (aFirstNameContains && !bFirstNameContains) return -1
        if (!aFirstNameContains && bFirstNameContains) return 1
        if (aLastNameContains && !bLastNameContains) return -1
        if (!aLastNameContains && bLastNameContains) return 1

        return 0
      })

      return filteredArray.concat(restArray)
    }

    const sorted = filterString
      ? sortArrayByFilterString(filterString, originalArray)
      : originalArray
    setSortedArray(sorted)
  }, [filterString, originalArray])

  return sortedArray
}

export { useStudentListSortedByFilterString }
